var map = {
	"./illustration_arab.png": "4bf9",
	"./illustration_ch.png": "31be",
	"./illustration_en.png": "efef",
	"./illustration_es.png": "24d7",
	"./illustration_fran.png": "45a1",
	"./illustration_por.png": "c55f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "daa7";